import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import PersistentPlayer from "@/components/PersistentPlayer";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="flex min-h-screen flex-col bg-brand-paper">
      <Header />
      <main className="flex-1 pb-24">{children}</main>
      <Footer />
      <PersistentPlayer />
    </div>
  );
}
